import { InfoOutlined } from "@mui/icons-material";
import { Box, IconButton, Tooltip, styled, tooltipClasses } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { Chart as ChartJS, ArcElement, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

import React from "react";
ChartJS.register(ArcElement, Legend);
const options = {
    responsive: true,

    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
    },
};

const DeviceBreakdown = () => {
    const theme = useTheme();

    const data = {
        labels: ["Desktop", "Tablet", "Mobile"],
        datasets: [
            {
                label: "Devices",
                data: [12, 12, 12],
                backgroundColor: [
                    theme.palette.primary.main,
                    theme.palette.secondary.main,
                    theme.palette.primaryTertiary.main,
                ],
                // borderColor: ["#587A4D", "#E1A325", "#B9D1B1"],
                borderWidth: 1,
            },
        ],
    };

    const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
        ({ theme }) => ({
            [`& .${tooltipClasses.tooltip}`]: {
                backgroundColor: "#fff",
                maxWidth: 320,
                borderRadius: 10,
                padding: 10,
            },
        }),
    );
    return (
        <div className="pt-8 bg-white border border-slate-100 rounded-[10px] h-full">
            <div className="px-8  font-bold text-xl text-slate-600  flex w-full justify-between items-center">
                <span>Device breakdown</span>
                <HtmlTooltip
                    placement="left"
                    title={
                        <>
                            <div className="shadow-xl px-4 py-2 rounded-lg">
                                <div className="font-bold text-base text-slate-600">Device breakdown</div>
                                <p className="text-slate-600">
                                    This graph shows what percent of your visitor sessions are done using a desktop or
                                    laptop, tablet, or mobile device
                                </p>
                            </div>
                        </>
                    }
                >
                    <IconButton>
                        <InfoOutlined></InfoOutlined>
                    </IconButton>
                </HtmlTooltip>
            </div>
            <div className="p-2 md:p-4 lg:p-8 space-y-5 w-full">
                <div className="grid lg:grid-cols-6 grid-cols-1 w-full gap-y-5 mt-5 md:mt-0 md:gap-y-0">
                    <div className="col-span-4 flex justify-center">
                        <Pie data={data} options={options} />
                    </div>
                    <div className="col-span-2 flex  items-center justify-center ">
                        <div className="md:space-y-3 space-x-4 md:space-x-0 flex flex-row md:flex-col">
                            <div className="flex items-center space-x-2">
                                <Box
                                    sx={{ backgroundColor: theme.palette.primary.main }}
                                    className="rounded-full w-4 h-4"
                                ></Box>
                                <span className="text-slate-600">Desktop</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <Box
                                    sx={{ backgroundColor: theme.palette.secondary.main }}
                                    className="rounded-full w-4 h-4"
                                ></Box>
                                <span className="text-slate-600">Tablet</span>
                            </div>
                            <div className="flex items-center space-x-2">
                                <Box
                                    sx={{ backgroundColor: theme.palette.primaryTertiary.main }}
                                    className="rounded-full w-4 h-4"
                                ></Box>
                                <span className="text-slate-600">Mobile</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeviceBreakdown;
